import { useMutation, useQuery } from '@tanstack/react-query';

import { authApi, type UpdateProfilePayload } from '@/api/auth';
import { useAuthStore } from '@/stores/authStore';

export function useMe() {
  const token = useAuthStore((s) => s.token);
  const setUser = useAuthStore((s) => s.setUser);
  return useQuery({
    queryKey: ['auth', 'me'],
    queryFn: async () => {
      const user = await authApi.me();
      setUser(user);
      return user;
    },
    enabled: Boolean(token),
    staleTime: 60_000,
  });
}

export function useSendCode() {
  return useMutation({
    mutationFn: (phone: string) => authApi.sendCode(phone),
  });
}

export function useVerifyCode() {
  const setSession = useAuthStore((s) => s.setSession);
  return useMutation({
    mutationFn: ({ phone, code }: { phone: string; code: string }) =>
      authApi.verify(phone, code),
    onSuccess: (data) => {
      setSession(data.user, data.token);
    },
  });
}

export function useUpdateProfile() {
  const setUser = useAuthStore((s) => s.setUser);
  return useMutation({
    mutationFn: (payload: UpdateProfilePayload) => authApi.updateProfile(payload),
    onSuccess: (user) => {
      setUser(user);
    },
  });
}
